import React, { useState, useEffect } from 'react';
import { Row, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { postBookRequest } from '../../../firebase-config';

function BookRequestPage({ employee }) {
    useEffect(() => {
        document.title = "書籍購入申請";
    }, []);

    const [url, setUrl] = useState('');
    const [note, setNote] = useState('');
    const [isValidUrl, setIsValidUrl] = useState(true);
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);

    const handleUrlChange = (e) => {
        const value = e.target.value;
        setUrl(value);
        if (value) {
            try { new URL(value); setIsValidUrl(true); }
            catch { setIsValidUrl(false); }
        } else {
            setIsValidUrl(true);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setShowSuccess(false);
        setShowError(false);

        try {
            await postBookRequest(
                employee.id,
                employee.legechId,
                employee.slackMemberId,
                url.trim(),
                note.trim()
            );
            setShowSuccess(true);
            setUrl('');
            setNote('');
        } catch (error) {
            setShowError(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Row>
            <h1>書籍購入申請</h1>

            <Form onSubmit={handleSubmit} className='p-4'>
                <Form.Group className='mb-3'>
                    <Form.Label className='fw-bold'>申請URL <span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                        type='text'
                        value={url}
                        onChange={handleUrlChange}
                        placeholder='https://...'
                        isInvalid={!isValidUrl}
                        required
                    />
                    <Form.Control.Feedback type='invalid'>
                        URLが無効です。
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className='mb-4'>
                    <Form.Label className='fw-bold'>備考</Form.Label>
                    <Form.Control
                        as='textarea'
                        rows={3}
                        maxLength={500}
                        value={note}
                        onChange={e => setNote(e.target.value)}
                        placeholder='任意'
                    />
                </Form.Group>

                <div className='d-grid gap-2'>
                    <Button variant='primary' type='submit' size='lg' disabled={loading || !isValidUrl}>
                        {loading ? '送信中...' : '申請する'}
                    </Button>
                    {loading && <Spinner animation='border' variant='dark' className='mx-auto' />}
                </div>
            </Form>

            {showSuccess && <Alert variant='success'>申請を送信しました。</Alert>}
            {showError && <Alert variant='danger'>送信に失敗しました。</Alert>}
        </Row>
    );
}

export default BookRequestPage;
